import { DependencyList, useEffect } from "react";
import { EventRegister } from "react-native-event-listeners";

export default function useEventReciever(name: string, func?: (data: any) => void, deps: DependencyList = []) {
  useEffect(() => {
    const event = EventRegister.addEventListener(name, (data) => func?.(data));
    return () => { EventRegister.rm(event.toString()); }
  }, deps);
}